import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { take } from "rxjs/operators";
import { getStorage, ref, getDownloadURL, uploadBytes } from "firebase/storage";

import { arrayUnion } from 'firebase/firestore'
import { uploadString } from "@angular/fire/storage";
import { Storage } from '@ionic/storage';
import { Injectable, Injector } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {

  private snapshotChangesSubscription: any;

  checkins = null;
  user_checkins = null;
  total_user_checkins = null;
  user_exercices = null;
  user_cles = null;
  initiatives = null;
  communes = null;
  challenges = null;
  zeroKmSituations = null;
  zeroKmProposition = null;
  storage: any;

  constructor(
    public afs: AngularFirestore,
    public afAuth: AngularFireAuth,
    private injector: Injector
  ) {
    this.storage = this.injector.get(Storage)
  }

  getDateKey() {
    return (new Date().getDate() + 0) + '_' + (new Date().getMonth() + 1) + '_' + new Date().getFullYear();
  }


  getDateKeyCustom(date: Date) {
    return (new Date(date).getDate() + 0) + '_' + (new Date(date).getMonth() + 1) + '_' + new Date(date).getFullYear();
  }

  async getTotalUserCheckins(user_id) {
    if (this.total_user_checkins == null)
      await this.getTotalUserCheckinsFirebase(user_id);

    return this.total_user_checkins;
  }

  async getUserCheckins(user_id) {
    if (this.user_checkins == null)
      await this.getUserCheckinsFirebase(user_id);

    return this.user_checkins;
  }

  async getCheckins() {
    if (this.checkins == null)
      await this.getCheckinsFirebase();

    return this.checkins;
  }

  async getUserExercices(user_id) {
    if (this.user_exercices == null)
      await this.getUserExercicesFirebase(user_id);

    return this.user_exercices;
  }

  async getUserCles(user_id) {
    if (this.user_cles == null)
      await this.getUserClesFirebase(user_id);

    return this.user_cles;
  }

  resetUserCheckins() {
    this.user_checkins = null;
  }

  resetCheckins() {
    this.checkins = null;
  }

  resetUserExercices() {
    this.user_exercices = null;
  }

  resetUserCles() {
    this.user_cles = null;
  }

  listCompagnies() {
    return new Promise<any>((resolve, reject) => {
      let snapshotChangesRef = this.afs.collection('companies')
      snapshotChangesRef.snapshotChanges()
        .pipe(take(1))
        .subscribe(snapshots => {
          let result = snapshots.map(a => {
            const data: any = a.payload.doc.data();
            const id = a.payload.doc["id"];
            return { id, ...data };
          });
          resolve(result);
        }, err => {
          reject(err)
        })
    })
  }




  getCompanyFirebase(company_id) {
    console.log("getCompanyFirebase", company_id)
    return new Promise<any>((resolve, reject) => {
      let snapshotChangesRef = this.afs
        .collection('companies')
        .doc(company_id);
      snapshotChangesRef.snapshotChanges()
        .pipe(take(1))
        .subscribe(snapshot => {
          console.log("snapshot", snapshot);
          let data: any = snapshot.payload.data();
          const id = snapshot.payload["id"];
          resolve({ id, ...data });
        }, err => {
          reject(err)
        })
    })

  }
  getCompanyCheckinsFirebase(company_id, key_date = this.getDateKey()) {
    console.log("getCompanyCheckinsFirebase", company_id, key_date)
    return new Promise<any>((resolve, reject) => {
      let snapshotChangesRef = this.afs
        .collection('companies')
        .doc(company_id)
        .collection('checkins')
        .doc(key_date);//.orderBy('rank', 'asc').limit(400));
      snapshotChangesRef.snapshotChanges()
        .pipe(take(1))
        .subscribe(snapshot => {
          console.log("snapshot", snapshot);
          let data: any = snapshot.payload.data();
          if (!data)
            data = {};
          resolve(data);
        }, err => {
          reject(err)
        })
    })

  }

  addCommunauteCheckins(type, key_name, user_checkins) {
    console.log("addCommunauteCheckins", type, key_name, user_checkins);
    return new Promise<any>((resolve, reject) => {
      key_name = key_name.toLowerCase();
      this.afs.collection('communaute_' + type).doc(key_name)
        .set({ name: key_name })
        .then(
          res => resolve(res),
          err => {
            console.error("addCommunauteCheckins err", err)
            reject(err);
          }
        )
      this.afs.collection('communaute_' + type).doc(key_name).collection('checkins')
        .doc(this.getDateKey())
        .set(
          { checkins: arrayUnion(user_checkins) },
          { merge: true }
        )
        .then(
          res => resolve(res),
          err => {
            console.error("addCommunauteCheckins err", err)
            reject(err);
          }
        )
    })
  }

  getCommunaute(type) {
    return new Promise<any>((resolve, reject) => {
      let snapshotChangesRef = this.afs.collection('communaute_' + type)
      snapshotChangesRef.snapshotChanges()
        .pipe(take(1))
        .subscribe(snapshots => {
          let result = snapshots.map(a => {
            const data: any = a.payload.doc.data();
            const id = a.payload.doc["id"];
            return { id, ...data };
          })

          resolve(result);
        }, err => {
          reject(err)
        })
    })
  }

  getCommunauteCheckins(type, name, key_date) {
    return new Promise<any>((resolve, reject) => {
      let snapshotChangesRef = this.afs.collection('communaute_' + type)
        .doc(name)
        .collection('checkins')
        .doc(key_date);
      snapshotChangesRef.valueChanges()
        .pipe(take(1))
        .subscribe(data => {
          resolve(data);
        }, err => {
          reject(err)
        })
    })
  }

  addCompanyCheckins(code_entreprise, user_checkins) {
    return new Promise<any>((resolve, reject) => {
      console.log("addCompanyCheckins", user_checkins);
      code_entreprise = code_entreprise.toLowerCase().replace(/\s/g, '');
      this.afs.collection('companies').doc(code_entreprise).collection('checkins')
        .doc(this.getDateKey())
        .set(
          { checkins: arrayUnion(user_checkins) },
          { merge: true }
        )
        .then(
          res => resolve(res),
          err => reject(err)
        )
    })
  }

  addGlobalCheckins(user_checkins) {
    return new Promise<any>((resolve, reject) => {
      console.log("addGlobalCheckins", user_checkins);
      this.afs.collection('global_checkins')
        .doc(this.getDateKey())
        .set(
          { checkins: arrayUnion(user_checkins) },
          { merge: true }
        )
        .then(
          res => resolve(res),
          err => {
            console.warn('err', err);
            reject(err)
          }
        )
    })
  }

  setCheckins(user_id, user_checkins) {
    return new Promise<any>((resolve, reject) => {
      console.log("setCheckins", user_id, user_checkins);
      this.afs.collection('users')
        .doc(user_id)
        .collection('checkins')
        .doc(new Date().getFullYear().toString())
        .set(user_checkins)
        .then(
          res => resolve(res),
          err => reject(err)
        )
    })
  }


  getTotalUserCheckinsFirebase(user_id) {
    return new Promise<any>((resolve, reject) => {
    // while(!empty){
      let total_user_checkins = 0;
      let snapshotChangesRef = this.afs
        .collection('users')
        .doc(user_id)
        .collection('checkins');
        snapshotChangesRef.snapshotChanges()
        .pipe(take(1))
        .subscribe(snapshot => {
          snapshot.map(a => { 
            console.log("a", a.payload.doc.data());
            total_user_checkins += Object.keys(a.payload.doc.data()).length;

          });
          console.log("total_user_checkins", total_user_checkins);
          this.total_user_checkins = total_user_checkins;
          resolve(this.total_user_checkins);
        }, err => {
          reject(err)
        })
    });
  }
  getUserCheckinsFirebase(user_id) {
    return new Promise<any>((resolve, reject) => {
      let snapshotChangesRef = this.afs
        .collection('users')
        .doc(user_id)
        .collection('checkins')
        .doc((new Date().getFullYear() - 1).toString());//.orderBy('rank', 'asc').limit(400));
      snapshotChangesRef.snapshotChanges()
        .pipe(take(1))
        .subscribe(snapshot => {
          console.log("snapshot", snapshot);
          let data: any = snapshot.payload.data();
          if (data == null)
            data = {};
          this.user_checkins = data;

          return this.afs
          .collection('users')
          .doc(user_id)
          .collection('checkins')
          .doc(new Date().getFullYear().toString())
          .snapshotChanges()
          .pipe(take(1))
          .subscribe(snapshot => {
            console.log("snapshot", snapshot);
            let data: any = snapshot.payload.data();
            if (data == null)
              data = {};
            console.log("user_checkins", JSON.parse(JSON.stringify(this.user_checkins)));
            this.user_checkins = {...this.user_checkins, ...data};
            console.log("user_checkins", JSON.parse(JSON.stringify(this.user_checkins)));
            resolve(data);
          }, err => {
            reject(err)
          })
        })
    })
  }

  getGlobalCheckinsFirebase(key_date = this.getDateKey()) {
    return new Promise<any>((resolve, reject) => {
      let snapshotChangesRef = this.afs.collection('global_checkins')
        .doc(key_date);//.orderBy('crea', 'asc'));// ref => ref.where('type', '==', type).orderBy('rank', 'asc').limit(400));
      snapshotChangesRef.valueChanges()
        .pipe(take(1))
        .subscribe(data => {
          resolve(data);
        }, err => {
          reject(err)
        })
    })
  }

  getCheckinsFirebase() {
    return new Promise<any>((resolve, reject) => {
      let snapshotChangesRef = this.afs.collection('checkins');//.orderBy('crea', 'asc'));// ref => ref.where('type', '==', type).orderBy('rank', 'asc').limit(400));
      snapshotChangesRef.snapshotChanges()
        .pipe(take(1))
        .subscribe(snapshots => {
          let result = snapshots.map(a => {
            const data: any = a.payload.doc.data();
            const id = a.payload.doc["id"];
            return { id, ...data };
          });
          this.checkins = result;
          resolve(result);
        }, err => {
          reject(err)
        })
    })
  }

  async getCommunes() {
    if (this.communes == null)
      await this.getCommunesFirebase();

    return this.communes;
  }

  resetCommunes() {
    this.communes = null;
  }

  getCommunesFirebase() {
    return new Promise<any>((resolve, reject) => {
      let snapshotChangesRef = this.afs.collection('communes');//.orderBy('crea', 'asc'));// ref => ref.where('type', '==', type).orderBy('rank', 'asc').limit(400));
      snapshotChangesRef.snapshotChanges()
        .pipe(take(1))
        .subscribe(snapshots => {
          let result = snapshots.map(a => {
            const data: any = a.payload.doc.data();
            const id = a.payload.doc["id"];
            return { id, ...data };
          });
          this.communes = result;
          resolve(result);
        }, err => {
          reject(err)
        })
    })
  }


  async getChallenges() {
    if (this.challenges == null)
      await this.getCommunesFirebase();

    return this.challenges;
  }

  resetChallenges() {
    this.challenges = null;
  }
  addHours(date, hours) {
    const dateCopy = new Date(date.getTime());
    const hoursToAdd = hours * 60 * 60 * 1000;
    dateCopy.setTime(date.getTime() + hoursToAdd);
    return new Date(dateCopy).toISOString();
  }
  getChallengesFirebase() {
    return new Promise<any>((resolve, reject) => {
      let snapshotChangesRef = this.afs.collection('challenges')
        .doc(new Date().getFullYear().toString());

      // .doc("2023");
      snapshotChangesRef.snapshotChanges()
        .pipe(take(1))
        .subscribe(snapshot => {
          let data: any = snapshot.payload.data();

          // if (data == null)
          //   data = this.createChallenges()
          // const myObject = {};
          // const ids = Object.keys(data);
          // console.log('ids', ids);
          // for (let oldKey of ids) {
          //   console.log('oldKey', oldKey);
          //   if (data[oldKey]) {
          //     let newKey = oldKey;
          //     newKey = newKey.replace("2023", "2024");
          //     const splitted = oldKey.split('_');
          //     const updatedDate = new Date();
          //     updatedDate.setDate(parseInt(splitted[0]));
          //     updatedDate.setMonth(parseInt(splitted[1]) - 1);
          //     // (splitted[0]) + '_' + (splitted[1]) + "_" + (new Date().getFullYear());
          //     console.log('updatedDate', updatedDate)
          //     // data[oldKey].date = new Date(data[oldKey].date.replace("2023-", "2024-")).setUTCHours(0, 0, 0, 0)
          //     data[oldKey].date = new Date(updatedDate).toISOString();
          //     // data[oldKey].date = this.addHours(new Date(data[oldKey].date), 12);
          //     myObject[newKey] = data[oldKey];
          //   }
          // }
          // console.log('createChallenges myObject', myObject);

          // this.challenges = myObject;
          // resolve(myObject);
          this.challenges = data;
          console.log('this.challenges', this.challenges)
          resolve(data);
        }, err => {
          reject(err)
        })
    })
  }



  setChallenges(challenges) {
    return new Promise<any>((resolve, reject) => {
      console.log("setChallenges", challenges);
      this.afs.collection('challenges')
        .doc(new Date().getFullYear().toString())
        .set(challenges)
        .then(
          res => resolve(res),
          err => reject(err)
        )
    })
  }

  createChallenges() {
    var now = new Date();
    var challenges = {};
    let key = (new Date(2023, 0, 1).getDate() + 0) + '_' + (new Date(2023, 0, 1).getMonth() + 1) + '_' + new Date(2023, 0, 1).getFullYear();
    for (var d = new Date(2023, 0, 1); d <= new Date(2023, 11, 31); d.setDate(d.getDate() + 1)) {

      key = (d.getDate() + 0) + '_' + (d.getMonth() + 1) + '_' + d.getFullYear();
      challenges[key] = {
        date: d.toISOString(),
        title: '#ReussysChallenge',
        text: '',
        emojis: '',
      }
    }
    return challenges;
  }

  uploadBase64(base64, folder, id_user = true) {
    let randomId = Math.random().toString(36).substr(2, 5);
    return new Promise<any>((resolve, reject) => {
      this.afAuth.user.subscribe(currentUser => {
        const storage = getStorage();
        console.log("uploadBase64", folder, currentUser['uid'], randomId)
        let imageRef = ref(storage, folder + '/' + currentUser['uid'] + '/' + randomId);
        if (!id_user) {
          imageRef = ref(storage, folder + '/' + randomId);
        }
        uploadString(imageRef, base64, 'data_url').then((snapshot) => {
          getDownloadURL(snapshot.ref).then((url) => {
            resolve({
              snapshot: snapshot,
              url: url
            })
          })
        });
      })
    })
  }

  createUser(uid, user) {
    return new Promise<any>((resolve, reject) => {
      console.log("createUser", user);
      this.afs.collection('users').doc(uid).set(user)
        .then(
          res => resolve(res),
          err => reject(err)
        )
    })
  }


  updateUser(user) {
    return new Promise<any>((resolve, reject) => {
      this.afAuth.user.subscribe(currentUser => {
        if (currentUser) {
          user.id = currentUser.uid;

          console.log("updateUser", user);
          this.afs.collection('users').doc(user.id)
            .set(user)
            .then(
              res => resolve(res),
              err => reject(err)
            )
        }
      });
    });
  }


  getUserLogged() {
    return new Promise<any>((resolve, reject) => {
      this.afAuth.user.subscribe(currentUser => {
        if (currentUser) {
          resolve(currentUser);
        }
      })
    })
  }

  async getUsersByCodeEntreprise(code_entreprise) {
    return new Promise<any>((resolve, reject) => {
      this.afs.collection('users', ref => ref.where('code_entreprise', '==', code_entreprise))
        .snapshotChanges()
        .pipe(take(1))
        .subscribe(snapshots => {
          let result = snapshots.map(a => {
            const data: any = a.payload.doc.data();
            const id = a.payload.doc["id"];
            return { id, ...data };
          });

          resolve(result);
        }, err => {
          reject(err)
        })
    });
  }
  async getUserByEmail(email) {
    return new Promise<any>((resolve, reject) => {
      this.afs.collection('users', ref => ref.where('email', '==', email))
        .snapshotChanges()
        .pipe(take(1))
        .subscribe(snapshots => {
          let result = snapshots.map(a => {
            const data: any = a.payload.doc.data();
            const id = a.payload.doc["id"];
            return { id, ...data };
          });

          resolve(result);
        }, err => {
          reject(err)
        })
    });
  }
  async getUser(id = null) {
    return new Promise<any>(async (resolve, reject) => {
      if (id == null) {
        await this.afAuth.user.subscribe(async currentUser => {
          console.log("currentUser", currentUser);
          if (currentUser) {
            id = currentUser.uid;
          }

          console.log("getUser", id);
          await this.afs.doc<any>('users/' + id).valueChanges()
            .pipe(take(1))
            .subscribe(snapshots => {
              console.log("snapshots", snapshots);
              resolve(snapshots);
            }, err => {
              reject(err)
            })
        });
      }
      else {
        console.log("getUser", id);
        await this.afs.doc<any>('users/' + id).valueChanges()
          .pipe(take(1))
          .subscribe(snapshots => {
            console.log("snapshots", snapshots);
            resolve(snapshots);
          }, err => {
            reject(err)
          })
      }
    });
  }

  setUserCleFirebase(user_id, cle_id, reponse) {
    return new Promise<any>(async (resolve, reject) => {
      console.log("setCleUser", user_id, cle_id, reponse);

      await this.storage.set('users_' + user_id + '_cles', null);
      this.afs.collection('users')
        .doc(user_id)
        .collection('cles')
        .doc(cle_id)
        .set(reponse)
        .then(
          res => resolve(res),
          err => reject(err)
        )
    })
  }

  getUserCleFirebase(user_id, cle_id) {
    return new Promise<any>((resolve, reject) => {
      let snapshotChangesRef = this.afs
        .collection('users')
        .doc(user_id)
        .collection('cles')
        .doc(cle_id);
      snapshotChangesRef.snapshotChanges()
        .pipe(take(1))
        .subscribe(snapshot => {
          console.log("snapshot", snapshot);
          let data: any = snapshot.payload.data();
          if (data == null)
            data = {};
          resolve(data);
        }, err => {
          reject(err)
        })
    })
  }

  async getUserClesFirebase(user_id, admin = false) {
    console.log('getUserClesFirebase', user_id, admin)
    let user_cles = await this.storage.get('users_' + user_id + '_cle');
    if (user_cles !== null && !admin) {
      var diff = Math.abs(user_cles.date - new Date().getTime()) / 3600000;
      console.log('getUserClesFirebase from storage', diff, user_cles);
      if (diff < 24) {
        this.user_cles = user_cles.result;
        return this.user_cles;
      }
    }

    return new Promise<any>((resolve, reject) => {
      let snapshotChangesRef = this.afs
        .collection('users')
        .doc(user_id)
        .collection('cles')
      snapshotChangesRef.snapshotChanges()
        .pipe(take(1))
        .subscribe(snapshot => {
          let result = snapshot.map(a => {
            const data: any = a.payload.doc.data();
            const id = a.payload.doc["id"];
            return { id, ...data };
          });
          console.log('getUserClesFirebase from database', result);
          this.user_cles = result;
          this.storage.set('users_' + user_id + '_cle', { result, date: new Date().getTime() });

          resolve(result);
        }, err => {
          reject(err)
        })
    })
  }

  setUserExerciceFirebase(user_id, exercice_id, reponse) {
    return new Promise<any>(async (resolve, reject) => {
      console.log("setExerciceUser", user_id, exercice_id, reponse);
      await this.storage.set('users_' + user_id + '_exercices', null);
      this.afs.collection('users')
        .doc(user_id)
        .collection('exercices')
        .doc(exercice_id)
        .set(reponse)
        .then(
          res => resolve(res),
          err => reject(err)
        )
    })
  }

  async getUserExerciceFirebase(user_id, exercice_id) {

    return new Promise<any>((resolve, reject) => {
      let snapshotChangesRef = this.afs
        .collection('users')
        .doc(user_id)
        .collection('exercices')
        .doc(exercice_id);
      snapshotChangesRef.snapshotChanges()
        .pipe(take(1))
        .subscribe(snapshot => {
          console.log("snapshot", snapshot);
          let data: any = snapshot.payload.data();
          if (data == null)
            data = {};

          resolve(data);
        }, err => {
          reject(err)
        })
    })
  }

  async getUserExercicesFirebase(user_id, storage =  true, admin = false) {
    console.log('getUserExercicesFirebase', user_id, storage, admin)
    let user_exercices = await this.storage.get('users_' + user_id + '_exercices');
    if (user_exercices !== null && storage && !admin) {
      var diff = Math.abs(user_exercices.date - new Date().getTime()) / 3600000;
      console.log('getUserExercicesFirebase from storage', diff, user_exercices);
      if (diff < 24) {
        // return user_exercices.result;
        this.user_exercices = user_exercices.result;
        return this.user_exercices;
      }
    }
    return new Promise<any>((resolve, reject) => {
      let snapshotChangesRef = this.afs
        .collection('users')
        .doc(user_id)
        .collection('exercices')
      snapshotChangesRef.snapshotChanges()
        .pipe(take(1))
        .subscribe(snapshot => {
          console.log('getUserExercicesFirebase from firebase');
          let result = snapshot.map(a => {
            const data: any = a.payload.doc.data();
            const id = a.payload.doc["id"];
            return { id, ...data };
          });
          this.user_exercices = result;
          this.storage.set('users_' + user_id + '_exercices', { result, date: new Date().getTime() });
          resolve(result);
        }, err => {
          reject(err)
        })
    })
  }

  setCommunitiesFirebase(id, type, valeur) {
    return new Promise<any>((resolve, reject) => {
      console.log("setCommunitiesFirebase", id);
      this.afs.collection('communities')
        .doc(id)
        .set(
          { [type]: arrayUnion(valeur.toLowerCase()) },
          { merge: true }
        )
        .then(
          res => resolve(res),
          err => reject(err)
        )
    })
  }

  getCommunitiesFirebase() {
    return new Promise<any>((resolve, reject) => {
      let snapshotChangesRef = this.afs.collection('communities');
      snapshotChangesRef.snapshotChanges()
        .pipe(take(1))
        .subscribe(snapshots => {
          let result = snapshots.map(a => {
            const data: any = a.payload.doc.data();
            const id = a.payload.doc["id"];
            return { id, ...data };
          });
          resolve(result);
        }, err => {
          reject(err)
        })
    })
  }



  async getZeroKmSituations() {
    if (this.zeroKmSituations == null)
      await this.getZeroKmSituationsFirebase();

    return this.zeroKmSituations;
  }

  resetZeroKmSituations() {
    this.zeroKmSituations = null;
  }

  getZeroKmSituationsFirebase() {
    return new Promise<any>((resolve, reject) => {
      let snapshotChangesRef = this.afs.collection('0km_situations');
      snapshotChangesRef.snapshotChanges()
        .pipe(take(1))
        .subscribe(snapshots => {
          let result = snapshots.map(a => {
            const data: any = a.payload.doc.data();
            data['id'] = a.payload.doc["id"];
            return data;
          });
          this.zeroKmSituations = result;
          resolve(result);
        }, err => {
          reject(err)
        })
    })
  }



  updateZeroKmSituations(id_situation, situation) {
    return new Promise<any>((resolve, reject) => {
      console.log("setZeroKmSituations", id_situation, situation);
      this.afs.collection('0km_situations')
        .doc(id_situation)
        .set(situation)
        .then(
          res => resolve(res),
          err => reject(err)
        )
    })
  }

  addZeroKmSituations(situation) {
    return new Promise<any>((resolve, reject) => {
      console.log("addZeroKmSituations", situation);
      this.afs.collection('0km_situations')
        .add(situation)
        .then(
          res => resolve(res),
          err => reject(err)
        )
    })
  }


  deleteZeroKmSituations(situation) {
    return new Promise<any>((resolve, reject) => {
      console.log("deleteZeroKmSituations", situation);
      this.afs.collection('0km_situations').doc(situation.id)
        .delete()
        .then(
          res => resolve(res),
          err => reject(err)
        )
    })
  }

  async getZeroKmProposition() {
    if (this.zeroKmProposition == null)
      await this.getZeroKmPropositionFirebase();

    return this.zeroKmProposition;
  }

  resetZeroKmProposition() {
    this.zeroKmProposition = null;
  }

  getZeroKmPropositionFirebase() {
    return new Promise<any>((resolve, reject) => {
      let snapshotChangesRef = this.afs.collection('0km_proposition');
      snapshotChangesRef.snapshotChanges()
        .pipe(take(1))
        .subscribe(snapshots => {
          let result = snapshots.map(a => {
            const data: any = a.payload.doc.data();
            data['id'] = a.payload.doc["id"];
            return data;
          });
          this.zeroKmProposition = result;
          resolve(result);
        }, err => {
          reject(err)
        })
    })
  }



  updateZeroKmProposition(id_proposition, proposition) {
    return new Promise<any>((resolve, reject) => {
      console.log("setZeroKmProposition", id_proposition, proposition);
      this.afs.collection('0km_proposition')
        .doc(id_proposition)
        .set(proposition)
        .then(
          res => resolve(res),
          err => reject(err)
        )
    })
  }

  addZeroKmProposition(proposition) {
    return new Promise<any>((resolve, reject) => {
      console.log("addZeroKmProposition", proposition);
      this.afs.collection('0km_proposition')
        .add(proposition)
        .then(
          res => resolve(res),
          err => reject(err)
        )
    })
  }
  deleteZeroKmProposition(proposition) {
    return new Promise<any>((resolve, reject) => {
      console.log("deleteZeroKmProposition", proposition);
      this.afs.collection('0km_proposition').doc(proposition.id)
        .delete()
        .then(
          res => resolve(res),
          err => reject(err)
        )
    })
  }

  unsubscribeOnLogOut() {
    //remember to unsubscribe from the snapshotChanges
    console.log("this.snapshotChangesSubscription", this.snapshotChangesSubscription);
    if (this.snapshotChangesSubscription != null)
      this.snapshotChangesSubscription.unsubscribe();
  }
}
